import React from "react";
import { useContext } from "react";
import { I18nReactContext } from "../../../../../contexts/I18nContext";
import { Button } from "../../../../Form/Button/Button";
import { Modal } from "../../../../Smart/Modal/Modal";
import { Confetti } from "../../../../Smart/Confetti/Confetti";
import { buttonColors } from "../../../../Pickers/InputTheme";
import finishExamConfetti from '../../../../../assets/images/session/finish-exam-confetti.svg';
import beeImage from '../../../../../assets/images/session/bee-instruction.png';
import './QuestionnaireSuccessModal.scss';
import useSignDocTypes from "../../../../../Hooks/useSignDocTypes";

export const QuestionnaireSuccessModal = ({ 
    open, 
    showConfetti, 
    onClose, 
    onGoHome,
    questionnaireType
}) => {
    const { i18n } = useContext(I18nReactContext);
    const { getNestedTranslation } = useSignDocTypes();

    // Get button text from configuration
    const buttonText = getNestedTranslation({
        type: questionnaireType,
        section: 'questionnaireSession',
        property: 'successButtonTextKey',
    });

    // Get congratulations title from configuration
    const congratsTitle = getNestedTranslation({
        type: questionnaireType,
        section: 'questionnaireSession',
        property: 'congratsTitleKey',
    });

    // Get congratulations message from configuration
    const congratsMessage = getNestedTranslation({
        type: questionnaireType,
        section: 'questionnaireSession',
        property: 'congratsMessageKey',
        defaultValue: i18n.translate('questionnaireSession.finishModal.congratsMessage')
    });

    return (
        <Modal
            open={open}
            onClose={onClose}>
            <div className="success-modal-content">
                <div className="success-container">
                    <div className="confetti-background">
                        <img src={finishExamConfetti} alt="confetti background" className="confetti-image" />
                    </div>
                    <div className="congrats-text">
                        <h1 className="main-congrats">{congratsTitle}</h1>
                        <p className="sub-congrats">{congratsMessage}</p>
                    </div>
                    <div className="action-row">
                        <div className="bee-container">
                            <img src={beeImage} alt="bee character" className="bee-image" />
                        </div>
                        <div className="button-container">
                            <Button
                                color={buttonColors.YELLOW}
                                onClick={onGoHome}
                                text={String(buttonText)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Confetti showConfetti={showConfetti}/>
        </Modal>
    );
} 